export default function SearchIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path
        d="M16.5 16.5002L12.8808 12.881M12.8808 12.881C13.4999 12.2619 13.991 11.527 14.326 10.7181C14.6611 9.90927 14.8335 9.04234 14.8335 8.16684C14.8335 7.29134 14.6611 6.42441 14.326 5.61555C13.991 4.80669 13.4999 4.07174 12.8808 3.45267C12.2618 2.8336 11.5268 2.34252 10.718 2.00748C9.9091 1.67244 9.04217 1.5 8.16667 1.5C7.29117 1.5 6.42424 1.67244 5.61538 2.00748C4.80652 2.34252 4.07158 2.8336 3.4525 3.45267C2.20223 4.70295 1.49983 6.39868 1.49983 8.16684C1.49983 9.93499 2.20223 11.6307 3.4525 12.881C4.70278 14.1313 6.39851 14.8337 8.16667 14.8337C9.93483 14.8337 11.6306 14.1313 12.8808 12.881Z"
        stroke="#525051"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
